import { render, staticRenderFns } from "./StudentInformationReporting.vue?vue&type=template&id=a778c7f4&scoped=true&"
import script from "./StudentInformationReporting.vue?vue&type=script&lang=js&"
export * from "./StudentInformationReporting.vue?vue&type=script&lang=js&"
import style0 from "./StudentInformationReporting.vue?vue&type=style&index=0&id=a778c7f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a778c7f4",
  null
  
)

export default component.exports